import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["card", "collectionId", "collectionSlug", "context", "pageNumber", "queryType", "resultCount", "resultIndex", "searchTerm", "section"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { BreezeBadge, EcosystemCardLarge, InstallBadge, ProductTypeBadge } from 'trellis-ecosystem';
import { Paths } from '../../constants/paths';
import { getInstalledByCard, getProductTypeByCard, getSourceIdByCard } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontListingCard(_ref) {
  var _card$companyName, _card$description, _card$listingName;
  let {
      card,
      collectionId,
      collectionSlug,
      context,
      pageNumber,
      queryType,
      resultCount,
      resultIndex,
      searchTerm,
      section
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const firstProduct = card.products[0];
  const installed = getInstalledByCard(card);
  const productType = firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.productType;
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const searchResultEventProps = useMemo(() => Object.assign({
    companyName: card.companyName,
    componentType: 'EcosystemCardLarge',
    installed,
    listingId: card.listingId,
    pageNumber,
    resultCount,
    resultIndex,
    resultType: 'LISTING',
    search: searchTerm,
    section,
    slug: card.slug,
    sourceId: getSourceIdByCard(card),
    type: getProductTypeByCard(card),
    value: context === null || context === void 0 ? void 0 : context.value
  }, queryType && {
    queryType: String(queryType)
  }, collectionId && {
    collectionId,
    category: collectionSlug
  }), [card, collectionId, collectionSlug, context === null || context === void 0 ? void 0 : context.value, installed, pageNumber, queryType, resultCount, resultIndex, searchTerm, section]);
  const onLinkClick = () => {
    trackMarketplaceEvent(getSearchResultClickedEvent(searchResultEventProps));
  };
  return /*#__PURE__*/_jsx(SearchResultViewTracker, Object.assign({}, searchResultEventProps, {
    children: /*#__PURE__*/_jsx(EcosystemCardLarge, Object.assign({}, props, {
      badgesSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ProductTypeBadge, {
          agentType: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.agentType,
          productType: productType
        }), card.products.some(p => p.worksWithBreeze) && /*#__PURE__*/_jsx(BreezeBadge, {}), /*#__PURE__*/_jsx(InstallBadge, {
          installed: installed,
          installCount: card.installCount
        })]
      }),
      certified: firstProduct === null || firstProduct === void 0 ? void 0 : firstProduct.certified,
      companyName: (_card$companyName = card.companyName) !== null && _card$companyName !== void 0 ? _card$companyName : '',
      description: (_card$description = card.description) !== null && _card$description !== void 0 ? _card$description : '',
      imageSrcSmall: card.iconUrl,
      linkMode: "react-router",
      listingHref: card.slug ? generatePath(Paths.LISTING_DETAILS, {
        listingSlug: card.slug
      }) : undefined,
      name: (_card$listingName = card.listingName) !== null && _card$listingName !== void 0 ? _card$listingName : '',
      onLinkClick: onLinkClick,
      ribbonSlot: card.betaStage && /*#__PURE__*/_jsx(Ribbon, {
        position: "left",
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.cards.listingCard.beta"
        })
      })
    }))
  }));
}